import { SpcSamplingMethod } from "src/components/views/spc/masterData/controlCharts/form/samplingMethod/SpcSamplingMethod.tsx";
import i18n from "i18next";
import { FormTextField } from "src/components/common/forms/fields/FormTextField.tsx";

export const getCompleteProductTroughputSampling = (): SpcSamplingMethod => {
	return {
		key: "complete_product_throughput",
		label: i18n.t("complete_product_throughput"),
		renderParameterFields: ({ control }) => {
			return (
				<>
					<FormTextField
						control={control}
						name={"samplingParams.param1"}
						label={i18n.t("equipments")}
					/>
				</>
			);
		},
	};
};
